export const COLORS = [
  '#6092C0',
  '#96C060',
  '#F06292',
  '#FFB74D',
  '#4FC3F7',
  '#81C784',
  '#BA68C8',
  '#058DC7',
  '#DC143C',
  '#648C11',
  '#8A2BE2',
  '#FF7518',
  '#FFCC33',
  '#3399FF',
];

export const getColorByIndex = (index: number) => COLORS[index % COLORS.length];
